import React from 'react';

import get from 'lodash/get';

import {
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
} from '@gogame/components';
import { ScreenLink } from '@gogame/screens';

import { affiliatesLink } from 'scenes/Affiliates/navigation';
import { partnerCompaniesLink } from 'scenes/PartnerCompanies/navigation';

const RelatedEntities = ({ data, hasAffiliates, hasPartnerCompany }) => {
  return (
    <TableContainer>
      <Table width={'100%'}>
        <TableBody>
          {hasAffiliates ? (
            <TableRow>
              <TableCell>
                <ScreenLink
                  link={affiliatesLink}
                  params={{
                    searchQuery: get(data, 'affiliates')
                      .map(({ id }) => id)
                      .join(', '),
                  }}
                  target={'_blank'}
                >
                  Affiliates
                </ScreenLink>
              </TableCell>
            </TableRow>
          ) : null}
          {hasPartnerCompany ? (
            <TableRow>
              <TableCell>
                <ScreenLink
                  link={partnerCompaniesLink}
                  params={{
                    searchQuery: data.partnerCompany.id,
                  }}
                  target={'_blank'}
                >
                  Partner Company
                </ScreenLink>
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RelatedEntities;
